import { FC, useCallback, useRef, useState } from "react";
import { useResize } from "../../hooks";
import { MAX_MOBILE_WIDTH } from "../../constants";
import { Column } from "../../components/containers";
import ChatHeader from "./chat-header";
import { ChatProps } from "./types";
import ChatBody from "./chat-body";

const Chat: FC<ChatProps> = ({ isSidePanel = false }) => {
  const conRef = useRef<HTMLDivElement>(null);

  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const headerRef = useRef<HTMLDivElement>(null);

  useResize(
    useCallback(() => {
      if (!conRef.current) return;

      const width = window.getComputedStyle(conRef.current).width;
      const widthNumber = Number(width.substring(0, width.length - 2));

      if (widthNumber < MAX_MOBILE_WIDTH) setIsMobile(true);
      else setIsMobile(false);
    }, [])
  );

  return (
    <Column
      style={{
        margin: `1rem${isSidePanel ? " 1rem" : " 0"}`,
        height: `calc(100% - 2rem${isSidePanel ? " - 73px" : ""})`,
      }}
      containerRef={conRef}
    >
      <ChatHeader
        isMobile={isMobile}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        isSidePanel={isSidePanel}
        headerRef={headerRef}
      />

      <ChatBody
        isMobile={isMobile}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        isSidePanel={isSidePanel}
        headerRef={headerRef}
      />
    </Column>
  );
};

export default Chat;
